import styles from "./EndedSession.module.scss";

import { Trans, useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

type EndedSessionProps = {
  handleReschedule: () => void;
};

export const EndedSession = ({ handleReschedule }: EndedSessionProps) => {
  const { t } = useTranslation();
  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("sessionEnded.title")}</span>

        <Trans
          i18nKey="sessionEnded.description"
          components={{
            first: <p className={styles.description} />,
            second: <p className={styles.description} />,
          }}
        />

        <AppButton variant="critical" onClick={handleReschedule}>
          <span>{t("sessionEnded.button")}</span>
        </AppButton>
      </div>
    </PageContainer>
  );
};
